export function getPageFromUrl(url) {
    if (!url) {
      return null;
    }
  
    return url.split("?")[1].split("=")[1];
  }